export default {"src":"/_next/static/image/src/assets/warn.89e02aa3d315aaa539d5e035d12ddd79.svg","height":24,"width":24};